import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, Col } from 'react-bootstrap';
import CurrentUser from './CurrentUser'

const TopNav = ({ fixed }) => {
    return (
        <Navbar collapseOnSelect variant='main' fixed={fixed} className='top-nav'>
            <Container className='justify-content-start col-7 ps-1'>
                    <Col  xs={10} className='ps-0'>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img className="logo" src="/images/ClearPoint-Logo@3x.png" alt="ClearPoint logo" />
                            </Link>
                        </Navbar.Brand>
                    </Col>
                    <Col className='col-8 text-end me-auto align-items-end'>
                        <Navbar.Collapse>
                            <Nav className="quick-nav" >
                                <CurrentUser />
                            </Nav>
                        </Navbar.Collapse>
                    </Col>
            </Container>
        </Navbar>
    )
}

export default TopNav;